export default "__VITE_ASSET__DhZv9gFi__"